import { Link, Typography } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { ICellRendererParams } from 'ag-grid-community';
import { Link as RouterLink } from 'react-router-dom';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { LinkTarget } from 'core/enums';
import { getAgGridTableCellData } from 'core/utils';
import { Level, Size } from 'theme/enums';

import { Loader } from './Loader';

interface IProps extends ICellRendererParams {
  isLoading?: boolean;
  columnId?: string;
  path?: string;
  getPath?: (data: unknown) => string | null | undefined;
  target?: LinkTarget;
  external?: boolean;
  sx?: SxProps;
}

export const LinkCell = ({
  isLoading = false,
  columnId = 'id',
  value,
  path,
  getPath,
  target = LinkTarget.SELF,
  external = false,
  sx,
  ...rest
}: IProps) => {
  if (isLoading) {
    return <Loader size={Size.SM} />;
  }

  const data = getAgGridTableCellData({ value, ...rest }, columnId);
  if (!data) {
    return value;
  }

  const linkPath = path ? path : getPath ? getPath(data) : '';

  const getFullUrl = (url: string): string => {
    if (/^(?:[a-z+]+:)?\/\//i.test(url)) {
      return url;
    }

    if (/^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,}$/i.test(url)) {
      return `http://${url}`;
    }

    return url;
  };

  if (!value) {
    return DEFAULT_PLACEHOLDER;
  }

  if (!linkPath) {
    return (
      <Typography level={Level.BODY_SM} sx={sx}>
        {value}
      </Typography>
    );
  }

  return (
    <Link
      {...(external ? { href: getFullUrl(linkPath) } : { component: RouterLink, to: linkPath })}
      target={target}
      level={Level.BODY_SM}
      sx={sx}
    >
      {value}
    </Link>
  );
};
